import styles from './../AuthPage.module.scss';
import {signup} from '../../../api/auth';
import {useNavigate} from 'react-router-dom';
import {useMemo, useState} from 'react';

const Signup = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const canSubmit = useMemo(() => {
        const userNameLength = username.trim().length;
        const passwordLength = password.length;

        return userNameLength >= 3 && userNameLength <= 20
            && passwordLength >= 4 && userNameLength <= 20
            && !loading;
    }, [username, password, loading]);

    async function performSignup(event: React.FormEvent) {
        event.preventDefault();
        setError(null);
        setLoading(true);

        try {
            await signup(username.trim(), password);
            navigate('/lobby');
        } catch (e: any) {
            setError('Signup failed. Try another username or a stronger password.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.auth}>
            <div className={styles.auth__card}>
                <div className={styles.auth__brand}>
                    <div>
                        <h1 className={styles.auth__title}>Low Five</h1>
                        <div className={styles.auth__subtitle}>Create your account</div>
                    </div>
                </div>

                {error && <div className={styles.auth__error}>{error}</div>}

                <form className={styles.auth__form} onSubmit={performSignup}>
                    <div className={styles.auth__field}>
                        <label className={styles.auth__label} htmlFor="username">Username</label>
                        <input
                            id="username"
                            className={styles.auth__input}
                            name="username"
                            autoComplete="username"
                            placeholder="Pick a username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>

                    <div className={styles.auth__field}>
                        <label className={styles.auth__label} htmlFor="password">Password</label>
                        <input
                            id="password"
                            className={styles.auth__input}
                            name="password"
                            type="password"
                            autoComplete="new-password"
                            placeholder="Create a password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <button className={styles.auth__primaryBtn} type="submit" disabled={!canSubmit}>
                        {loading ? 'Creating…' : 'Create Account'}
                    </button>
                </form>

                <button className={styles.auth__secondaryBtn} onClick={() => navigate('/login')}>
                    Login Instead
                </button>

                <div className={styles.auth__footer}>
                    Username: 3-20 chars · Password: 4-20 chars
                </div>
            </div>
        </div>
    );
};

export default Signup;
